import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { LoginService } from './../../login/shared/login.service';
import { CebuBreakTime } from './breaktime.model';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BreaktimeCebuService {

  constructor(
    private http: HttpClient,
    private authenticate: LoginService) { }

  getStaffBreakTime(staffId: number, date: string): Observable<{data: CebuBreakTime | null, message: string, success: boolean}> {
    const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken() });
    let params = new HttpParams();
    params = params.append('staffId', staffId.toString());
    params = params.append('date', date);
    const options = { headers: headers, params: params };

    console.log(options);

    return this.http.get(environment.SERVER_URL + '/cebu_break', options).pipe(
                map(this.extractData),
                catchError(this.handleError),);
  }

  startBreakTime(staffId: number, duration: number): Observable<{message: string, success: boolean}> {
    const headers = new HttpHeaders({ 
      'Authorization': this.authenticate.getToken(),
      'Content-Type': 'application/json'
    });
    const body = {
      "staffId": staffId,
      "action": "start",
      "duration": duration
    }
    const options = { headers: headers };
    return this.http.post<{message: string, success: boolean}>(environment.SERVER_URL + '/cebu_break', body, options)
  }

  stopBreakTime(staffId: number): Observable<{data: {remaining: number}, message: string, success: boolean}> {
    const headers = new HttpHeaders({ 
      'Authorization': this.authenticate.getToken(),
      'Content-Type': 'application/json'
    });
    const body = {
      "staffId": staffId,
      "action": "stop"
    }

    const options = { headers: headers };
    return this.http.put<{data: {remaining: number}, message: string, success: boolean}>(environment.SERVER_URL + '/cebu_break/stop', body, options)
  }

  timesUp(staffId: number): void {
    const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken() });
    const options = { headers: headers };
    this.http.put(environment.SERVER_URL + `/cebu_break/timesup?staffId=${staffId}`, options).pipe(
      map(this.extractData),
      catchError(this.handleError),);

    return;
  }

  private extractData(res: any) {
    let body = res;
    return body.data || {};
  }

  private handleError (error: any) {
    console.log(error);
      let errMsg: string;
      if (error) {
      const body = error || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
      } else {
      errMsg = error.message ? error.message : error.toString();
      }
      console.error(errMsg);
      return observableThrowError(errMsg);
  }
}
